<template>
  <div
    v-if="uploadManager.allUploadsCompleted"
    aria-live="assertive"
    class="visually-hidden"
  >
    <span>{{ $localize('AllUploadsComplete') }}</span>
  </div>

  <div
    v-if="uploadManager.uploadsCount"
    class="dropdown"
  >
    <div class="uploading-nav-item__status">
      <span
        class="fa-regular fa-circle-notch fa-spin"
        aria-hidden="true"
      />
      <span
        class="d-none d-lg-inline ms-3"
        aria-hidden="true"
      >
        {{ $localize('UploadingItems', { itemCount: uploadManager.uploadsCount, percent: uploadManager.currentOverallProgress }) }}
      </span>
      <span
        class="d-lg-none ms-2"
        aria-hidden="true"
      >
        {{ $localize('Uploading') }}
      </span>
      <span class="visually-hidden">
        {{ $localize('UploadingItems', { itemCount: uploadManager.uploadsCount, percent: uploadManager.currentOverallProgress }) }}
      </span>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { useUploadManagerStore } from '@/VueCore/stores/uploadManagerStore';

  const uploadManager = useUploadManagerStore();
</script>